import * as React from 'react'
import {observer} from 'mobx-react-lite'
import {EnumBulkEditProperty, BulkEditPropertyProps, EnumEntry} from './BulkEditDialogProperties'
import Select, {SingleValue} from 'react-select'

interface BulkEditEnumControlProps {
    property: BulkEditPropertyProps
    shouldBlockCancelConfirmCallback: React.Dispatch<React.SetStateAction<boolean>>
    id?: string
}

interface Suggestion {
    label: string
    value: string
}

function _BulkEditEnumControl(props: BulkEditEnumControlProps) {
    const {property, id, shouldBlockCancelConfirmCallback} = props

    const enumProperty = property as EnumBulkEditProperty

    const toSuggestion = (entry: EnumEntry): Suggestion => {
        return {label: entry.name, value: entry.value.toString()}
    }

    const suggestions = Array.from(enumProperty).map(toSuggestion)
    const selectedSuggestion = suggestions.find(s => s.label === enumProperty.selectedKey)

    const onChange = React.useCallback(
        (newValue: SingleValue<Suggestion>) => {
            if (newValue) {
                enumProperty.selectKey(newValue.label)
            }
        },
        [enumProperty]
    )

    return (
        <Select
            id={id}
            value={selectedSuggestion}
            isClearable={false}
            name={enumProperty.name}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={onChange}
            options={suggestions}
            onMenuOpen={() => {
                shouldBlockCancelConfirmCallback(true)
            }}
            onMenuClose={() => {
                shouldBlockCancelConfirmCallback(false)
            }}
        />
    )
}

export const BulkEditEnumControl = observer(_BulkEditEnumControl)
